(function () {
  function initReviewCarousel(root) {
    var track = root.querySelector('[data-mig-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-mig-slide]'));
    var dotsWrap = root.querySelector('[data-mig-dots]');
    if (!slides.length || !dotsWrap) return;
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-mig-dot]'));
    var current = 0;
    var autoplayMs = 4000;
    var timer = null;
    var resumeTimer = null;

    function setActive(i) {
      current = i;
      dots.forEach(function (d, idx) {
        d.setAttribute('aria-current', idx === i ? 'true' : 'false');
      });
    }

    function goTo(i, jump) {
      var slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: jump ? 'auto' : 'smooth' });
      setActive(i);
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function startAutoplay() {
      stopAutoplay();
      timer = setInterval(next, autoplayMs);
    }
    function pauseThenResume() {
      stopAutoplay();
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, autoplayMs);
    }

    track.addEventListener('pointerdown', pauseThenResume);
    track.addEventListener('touchstart', pauseThenResume, { passive: true });

    track.addEventListener(
      'scroll',
      function () {
        pauseThenResume();
        var center = track.scrollLeft + track.clientWidth / 2;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (s, idx) {
          var sCenter = s.offsetLeft + s.clientWidth / 2;
          var dist = Math.abs(sCenter - center);
          if (dist < closestDist) {
            closestDist = dist;
            closest = idx;
          }
        });
        if (closest !== current) setActive(closest);
      },
      { passive: true }
    );

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () {
        goTo(idx);
        pauseThenResume();
      });
    });

    setActive(0);
    startAutoplay();
  }

  function initLightbox(root) {
    var trigger = root.querySelector('[data-mig-hero]');
    var overlay = document.querySelector('[data-mig-lightbox]');
    if (!trigger || !overlay) return;
    var overlayImg = overlay.querySelector('img');
    var heroImg = trigger.querySelector('img');

    function open() {
      if (heroImg && overlayImg) overlayImg.src = heroImg.currentSrc || heroImg.src;
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', open);
    overlay.addEventListener('click', close);
  }

  function init() {
    document.querySelectorAll('[data-mig-section]').forEach(function (root) {
      initReviewCarousel(root);
      initLightbox(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
